module.exports = __webpack_public_path__ + "img/auto_spin_btn.68453719.png";